const accessToken = localStorage.getItem('authUser')
export default accessToken
